import {
  Autocomplete,
  Box,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  TextField,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../constants/FieldsConst';
import { getLabelTypeEntity } from '../../constants/enumsConst';
import { dateformat, getDateTimezone, isSwitch } from '../../helpers';
import { getSearchCodesCodigosAction } from '../../store/Actions';
import { PARAMS_INVITADOS } from '../../store/Types';
import FechasPersonalizada from '../accesos/components/FechasPersonalizada';
import { checkModuleAccess } from '../modulos/modules.helpers';
import { getAllInvitadosAction } from './InvitadosAction';
import BotonFechas from './components/BotonFechas';
import ListadoInvitados from './components/ListadoInvitados';
import SwitchFechaComponent from './components/SwitchFecha';

const InvitadosView = () => {
  const dispatch = Redux.useDispatch();
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const codigosStore = Redux.useSelector((state) => state.codigos);
  const invitadosStore = Redux.useSelector((state) => state.invitados);

  const loginStore = Redux.useSelector((state) => state.login);
  const accessName = 'invitation';
  if (!checkModuleAccess(accessName, loginStore)) {
    window.location.href = '/dashboard';
  }

  const [isRango, setIsRango] = React.useState(false);
  const [dataCodes, setDataCodes] = React.useState([]);
  const [loadingDataCode, setLoadingDataCode] = React.useState(false);
  const [isFuturo, setIsFuturo] = React.useState(true);
  const [startDate, setStartDate] = React.useState(
    dateformat(null, { full: true })
  );
  const [endDate, setEndDate] = React.useState(null);
  const [codeSelect, setCodeSelect] = React.useState(null);
  const [searchQuery, setSearchQuery] = React.useState('');

  const timezone = entidadesStore.activo.country.timezone;

  const getParams = () => {
    return {
      entityId: entidadesStore.activo.id,
      ...invitadosStore.params,
      startDate: getDateTimezone(startDate, timezone),
      endDate: getDateTimezone(endDate, timezone),
      ...(searchQuery ? { q: searchQuery } : {}),
    };
  };

  async function getAll() {
    await getAllInvitadosAction(dispatch, getParams());
  }

  React.useEffect(() => {
    if (startDate || endDate) {
      getAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  React.useEffect(() => {
    if (searchQuery) {
      const payload = getParams();
      dispatch({
        type: PARAMS_INVITADOS,
        payload,
      });
      getAllInvitadosAction(dispatch, payload);
    } else {
      const payload = {
        ...invitadosStore.params,
        entityId: entidadesStore.activo.id,
      };
      if (invitadosStore.params.q) {
        delete payload.q;
        dispatch({
          type: PARAMS_INVITADOS,
          payload,
        });
        getAllInvitadosAction(dispatch, payload);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  React.useEffect(() => {
    const payload = {
      ...invitadosStore.params,
      entityId: entidadesStore.activo.id,
    };
    dispatch({
      type: PARAMS_INVITADOS,
      payload,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeSelect]);

  var delayTimer;
  function doSearch(text) {
    clearTimeout(delayTimer);
    setLoadingDataCode(true);
    delayTimer = setTimeout(async () => {
      await getSearchCodesCodigosAction(
        dispatch,
        entidadesStore.activo.id,
        text
      );
      setLoadingDataCode(false);
    }, 1000); // Will do the ajax stuff after 1000 ms, or 1 s
  }

  React.useEffect(() => {
    setDataCodes([]);
    if (codigosStore.searchCodes.length > 0) {
      codigosStore.searchCodes.map((code) => {
        return setDataCodes((old) => [
          ...old,
          {
            [CONST.ID]: code.id,
            [CONST.CODE]: code.code,
          },
        ]);
      });
    }
  }, [codigosStore.searchCodes]);

  const selectCode = (
    <Autocomplete
      freeSolo
      id={CONST.CODE}
      disableClearable
      options={dataCodes.map((option) => option.code)}
      size="small"
      loading={loadingDataCode}
      onChange={(event, newValue) => {
        const code = codigosStore.searchCodes.find((a) => a.code === newValue);
        setCodeSelect(code);
      }}
      onInputChange={(event, newInputValue) => {
        if (!newInputValue) {
          setCodeSelect(null);
          // Aquí puedes agregar más lógica si es necesario cuando newInputValue es vacío
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(e) => doSearch(e.target.value)}
          label={`Buscar por ${getLabelTypeEntity(
            entidadesStore.entityType.name
          )}`}
          InputProps={{
            ...params.InputProps,
            type: 'search',
            endAdornment: (
              <React.Fragment>
                {loadingDataCode ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );

  const searchInput = (
    <TextField
      id="search-q"
      label="Buscar por código o identificación"
      variant="outlined"
      size="small"
      fullWidth
      onChange={(e) => {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(() => {
          setSearchQuery(e.target.value);
        }, 1000);
      }}
      onBlur={(e) => {
        if (!e.target.value) {
          setSearchQuery('');
        }
      }}
      InputProps={{
        type: 'search',
      }}
    />
  );

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <Paper elevation={2} sx={{ p: 2, width: '100%' }}>
          <Grid
            container
            spacing={1}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Grid item md={3}>
              {/* Comentado el selector de código */}
              {/* {selectCode} */}
              {searchInput}
            </Grid>
            <Grid
              item
              md={isRango ? 3 : 6}
              sx={{ display: 'flex', flexDirection: 'row' }}
            >
              <Stack direction="row" alignItems="center">
                <BotonFechas
                  futuro={isFuturo}
                  dateRange={(start, end) => {
                    setStartDate(dateformat(start, { full: true }));
                    setEndDate(dateformat(end, { full: true }));
                  }}
                  setIsRango={(v) => setIsRango(v)}
                />
                {isSwitch(isFuturo, startDate, endDate) || isRango ? null : (
                  <Box sx={{ ml: 1 }}>
                    <SwitchFechaComponent
                      value={isFuturo}
                      onClickLeft={() => setIsFuturo(false)}
                      onClickRigth={() => setIsFuturo(true)}
                      onChange={(e) => setIsFuturo(e.target.checked)}
                    />
                  </Box>
                )}
              </Stack>
            </Grid>
            {isRango && (
              <FechasPersonalizada
                startDate={startDate}
                endDate={endDate}
                onStart={(value) => {
                  if (!value) return;
                  setStartDate(value);
                }}
                onEnd={(value) => {
                  if (!value) return;
                  setEndDate(value);
                }}
              />
            )}
          </Grid>
        </Paper>
      </Grid>
      <Grid item md={12}>
        <ListadoInvitados getParams={getParams} />
      </Grid>
    </Grid>
  );
};

export default InvitadosView;
